import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import type { z } from 'zod';
import { PaymentGroupsModel } from '../projects/_models/payment-group';
import { queryKeyMap } from '../review-sheet/utils/query-keys';

const PaymentGroupsModelElement = PaymentGroupsModel.element;

export const usePaymentGroups = <
  T = Array<z.infer<typeof PaymentGroupsModelElement>>,
>({
  projectId,
  select,
  enabled = true,
}: {
  projectId: string;
  select?: (data: z.infer<typeof PaymentGroupsModel>) => T;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: queryKeyMap.paymentGroups(projectId),
    queryFn: async () => {
      const paymentGroups = await axiosGet(
        `/api/projects/${projectId}/payment-groups/`,
      );
      return PaymentGroupsModel.parse(paymentGroups);
    },
    select,
    enabled: !!projectId && enabled,
  });
};
